<script>
import AttachmentConstants from "@common/constants/AttachmentConstants";
import PDF from "@common/asset/svg/pdf.svg";
import EXCEL from "@common/asset/svg/excel.svg";
import EML from "@common/asset/svg/eml.svg";
import MSG from "@common/asset/svg/msg.svg";
import ZIP from "@common/asset/svg/zip-file-format.svg";
import CSV from "@common/asset/svg/csv.svg";
import DOC from "@common/asset/svg/doc.svg";
import TXT from "@common/asset/svg/txt.svg";
import Compressor from 'compressorjs';
import {cloneDeep} from 'lodash';
const UploadMixin = {
  data() {
    return {
      PDF,
      EXCEL,
      EML,
      MSG,
      ZIP,
      CSV,
      DOC,
      TXT,
      dialogImageUrl: "",
      dialogVisible: false,
      selectedAttachmentIndex: -1,
      rotation: 0,
    };
  },
  computed: {
    selectedImageSrc() {
      return this.selectedAttachment ? this.setIcon(this.selectedAttachment): 
        (this.attachments && this.attachments.length ? this.setIcon(this.attachments[0]): null);
    },
    selectedAttachment() {
      return this.attachments[this.selectedAttachmentIndex] || {};
    },
  },
  methods: {
    checkDoubleExtension(fileParts) {
      if (fileParts.length > 2) {
        const knownExtensions = ['jpeg', 'msg', 'jpg', 'png', 'svg', 'pdf', 'txt', 'doc', 'docx', 'docm', 'xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv', 'eml', 'zip', 'exe', 'com', 'bin', 'dll', 'html', 'htm', 'php', 'pl', 'vbs', 'bat', 'scr', 'pif', 'js'];
        
        for (let i = 1; i < fileParts.length - 1; i++) {
          if (knownExtensions.includes(fileParts[i].toLowerCase())) {
            return true;
          }
        }
      }
      return false;
    },
    isValidFileFormat(fileExt, allowedFileFormats){
      return allowedFileFormats.length ? allowedFileFormats.includes(fileExt) : (AttachmentConstants.images.includes(fileExt) || AttachmentConstants.pdf.includes(fileExt)
        || AttachmentConstants.excel.includes(fileExt)  || AttachmentConstants.msg.includes(fileExt)
        || AttachmentConstants.zip.includes(fileExt));
    },
    addAttachment(file, fileList, index, allowedFileFormats = []) {
      const isSizeExceed = file.size / 1024 / 1024 < AttachmentConstants.maxMbSize;
      let fileExt = this.findFileExt(file);
      let isFileFormat = this.isValidFileFormat(fileExt, allowedFileFormats);

        // Check for double extensions
      const fileName = file.name;
      const fileParts = fileName.split('.');
      const hasDoubleExtension = this.checkDoubleExtension(fileParts);

      if(this.disableBoxOption){
        isFileFormat = AttachmentConstants.images.includes(fileExt);
      }
      if (!isSizeExceed) {   
        this.$errorMessage({ message: this.$getErr('FILE_SIZE_EXCEED')});
        fileList.pop();
      }
      else if (!isFileFormat) {
        this.$errorMessage({ message: this.$getErr('INVALID_FORMAT')});
        fileList.pop();
      }
      else if (hasDoubleExtension) {
        this.$errorMessage({ message: 'File with multiple extensions not allowed'});
        fileList.pop();
      }   else {
        if (AttachmentConstants.images.includes(fileExt)) {
          this.handleUpload(file,isFileFormat,index,fileList)
        }
        else if (index !== null) {
          this.$emit('addAttachments', file, index);
        } else {
          this.$emit('addAttachments', file);
        }
      }
    },
    handleUpload(file,isFileFormat,index,fileList) {
      let newFile = cloneDeep(file);
      let vm = this;
      new Compressor(file.raw, {
        strict: true,
        checkOrientation: true,
        maxWidth: undefined,
        maxHeight: undefined,
        minWidth: 0,
        minHeight: 0,
        width: undefined,
        height: undefined,
        resize: 'none',
        quality: 0.8,
        mimeType: '',
        convertTypes: 'image/png',
        convertSize: 5000000,
        success: function (result) {
          const formData= new File([result],file.name,{type: "image/jpeg", lastModified: Date.now()});
          newFile.size=formData.size;
          formData.uid=newFile.raw.uid;
          newFile.raw=formData
          newFile.url=window.URL.createObjectURL(formData)
          file=cloneDeep(newFile)
          if (!isFileFormat) {
            vm.$errorMessage({ message: vm.$getErr('INVALID_FORMAT')});
            fileList.pop();
          } else {
            if (index !== null) {
              vm.$emit('addAttachments', file, index);
            } else {
              vm.$emit('addAttachments', file);
            }
          }
        },
      });
    },
    handleExceed() {
      this.$errorMessage({ message: this.$getErr('UPLOAD_LIMIT_EXCEED')});
    },
    previewAttachment(file) {
      const idx = this.attachments.findIndex(a =>
        (a.uid && a.uid === file.uid) ||
        (a.id && a.id === file.id) ||
        (a.url && a.url === file.url) ||
        (a.attachment_url && a.attachment_url === file.attachment_url)
      );
      this.selectedAttachmentIndex = idx !== -1 ? idx : 0;
    },
    setIcon(file) {
      let Newfile = file[0] || file
      let fileExt = this.findFileExt(Newfile);
      if (AttachmentConstants.images.includes(fileExt)) {
        let IMAGE = Newfile.url || Newfile.attachment_url;
        return IMAGE;
      }
      else if (fileExt === 'csv') {
        return CSV;
      }
      else if (fileExt === 'doc' || fileExt === 'docx' || fileExt === 'docm') {
        return DOC;
      }
       else if (fileExt === 'txt') {
        return TXT;
      } 
        else if (fileExt === 'pdf') {
          return PDF;
     }  else if (AttachmentConstants.excel.includes(fileExt)) {
        return EXCEL;
      } else if (AttachmentConstants.msg.includes(fileExt)) {
        return MSG;
      } else if (AttachmentConstants.zip.includes(fileExt)) {
        return ZIP;
      }
    },
    handlePictureCardPreview(file) {
      let Newfile = file[0] || file
      let fileExt = this.findFileExt(Newfile);
      if (AttachmentConstants.images.includes(fileExt)) {
        if (this.showPreviewInParentComponent) {
          const data = { 
            dialogImageUrl: Newfile.url || Newfile.attachment_url,
            dialogVisible: true,
          };
          this.$emit('preview', data);
        } else {
          this.dialogImageUrl = Newfile.url || Newfile.attachment_url;
          this.dialogVisible = true;
        }
        // Trigger Image Preview
        this.$refs.thumbImage && this.$refs.thumbImage.$el.children[0].click()
      } else if (
        AttachmentConstants.pdf.includes(fileExt) ||
        AttachmentConstants.excel.includes(fileExt) ||
        AttachmentConstants.msg.includes(fileExt) ||
        AttachmentConstants.zip.includes(fileExt)
      ) {
        const link = this.$el.getElementsByClassName("download-file")[0];
        link.href = Newfile.url || Newfile.attachment_url;
        link.setAttribute("download", Newfile.name);
        link.setAttribute("target", "_blank");
        link.click();
      }
    },
    rotateRight() {
     this.rotation += 90
   },
    rotateLeft() {
     this.rotation -= 90
    },
    handleDownload(file) {
      const f = file[0] || file;
      if (!f || (!f.url && !f.attachment_url)) return;
      const link = this.$el.getElementsByClassName("download-file")[0];
      link.href = f.url || f.attachment_url;
      link.setAttribute("download", f.name || '');
      link.click();
    },
    findFileExt(file) {
      if(file.name) {
        const fileName = file.name;
        return fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
      } else if(file.url){
        const fileName = file.url;
        const index1 = ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        let index2 = fileName.indexOf("?");
        index2 = index2 === -1 ? fileName.length : index2;
        return fileName.slice(index1, index2).toLowerCase();
      }
    },
  }
};
export default UploadMixin;
</script>
